<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a v-if="usertype !== USER_TYPE.AIRPORT" href="#/map">
        <span>
          {{ $t("Map") }}
        </span>
      </a>
      <a v-else href="#/airportmap">
        <span>
          {{ $t("Map") }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
import { USER_TYPE } from "@/const";
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    avatar: {
      type: String,
      default: "./img/map.png"
    }
  },
  data() {
    return {
      isClosed: false,
      USER_TYPE: USER_TYPE
    };
  },
  computed: {
    ...mapFields("auth", ["email", "usertype"])
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
